<template>
  <div>
    <a-row :gutter="24" type="flex">
      <a-col :span="24" class="mb-24">
        <CardTemplateTable
          :data="templateData"
          :countries="countries"
          @refresh="fetchTemplates"
        ></CardTemplateTable>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { templateList } from "@/api/template";
import CardTemplateTable from "./components/CardTemplateTable";

export default {
  components: {
    CardTemplateTable,
  },
  data() {
    return {
      templateData: [],
      countries: [],
    };
  },
  methods: {
    fetchTemplates() {
      templateList().then((res) => {
        this.templateData = res.data.templates || [];
        this.countries = res.data.countries || [];
      });
    },
  },
  mounted() {
    this.fetchTemplates();
  },
};
</script>

<style lang="scss" scoped>
</style>
